import { css, styled } from 'styled-components';
import { COLORS, computeRemSize } from '@ydistri/theme';
import { DropdownProps, Select } from 'antd';
import { DefaultOptionType } from 'rc-select/lib/Select';

export const dropdownAlign: DropdownProps['align'] = { offset: [0, -6] };
const selectWidth = computeRemSize(500);
export type BackgroundVariant = 'default' | 'transparent-background';

interface StyledSelectProps {
  $backgroundVariant?: BackgroundVariant;
  $compact?: boolean;
  $fullWidth?: boolean;
}

interface OptionTitleProps {
  $fullWidth?: boolean;
}

export const OptionRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  min-height: ${computeRemSize(32)};
  font-size: ${computeRemSize(14)} !important;
  gap: 0.5rem;
  border-bottom: 1px solid ${COLORS.GREY_MEDIUM2};
`;

export const OptionLeft = styled.div`
  flex-basis: 3.5rem;
  text-align: right;
  padding-right: 0.25rem;
  min-width: 3.5rem;
`;

export const OptionTitle = styled.div<OptionTitleProps>`
  padding-left: 0.25rem;
  max-width: ${({ $fullWidth }) => ($fullWidth ? 'none' : `calc(${selectWidth} - 7rem)`)};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: normal;
`;

export const StyledSelect = styled(Select<number, DefaultOptionType>)<StyledSelectProps>`
  height: ${({ $compact }) => computeRemSize($compact ? 32 : 40)} !important;
  width: ${({ $fullWidth }) => ($fullWidth ? '100%' : selectWidth)} !important;

  &.ant-select {
    margin-left: 0 !important;
  }

  .ant-select-selector {
    height: ${({ $compact }) => computeRemSize($compact ? 32 : 40)} !important;
    font-size: ${computeRemSize(14)} !important;
    border-color: ${p => p.theme.colors.border} !important;
    ${p =>
      p.$backgroundVariant === 'transparent-background' &&
      css`
        background-color: ${p => p.theme.colors.pageBackground} !important;
      `}
  }

  .ant-select-selection-item {
    line-height: ${computeRemSize(16)} !important;
    display: flex !important;
    align-items: center !important;

    ${OptionRow} {
      border-bottom: 0;
    }
  }

  .ant-select-selection-search {
    display: flex !important;
    align-items: center !important;
  }

  .ant-select-selection-search-input {
    font-size: ${computeRemSize(14)} !important;
  }
`;
